import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

  const base = environment.api;

@Injectable({
  providedIn: 'root'
})

export class MantenimientosService {
 private api = `${environment.api}maintenance`;

  constructor(
    private http: HttpClient
  ) {}


  get token(): string {
    return localStorage.getItem('token') || '';
  }

  get headers() {
    return {
      headers: {
        'x-token': this.token
      }
    }
  }

  // =====================================================
  // MANTENIMIENTOS
  // =====================================================

  getMaintenance(): Observable<any> {
    return this.http.get<any>(this.api,this.headers);
  }


  getMaintenanceById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.api}/${id}`,this.headers
    );
  }


  createMaintenance(data: any): Observable<any> {
    return this.http.post<any>(
      this.api,
      data,this.headers
    );
  }


  updateMaintenance(
    id: number,
    data: any
  ): Observable<any> {

    return this.http.put<any>(
      `${this.api}/${id}`,
      data,this.headers
    );
  }


  updateMaintenanceStatus(
    id: number,
    status: string,
    user_id?: number
  ): Observable<any> {

    const data = {
      status,
      user_id
    };

    return this.http.put<any>(
      `${this.api}/${id}/status`,
      data,this.headers
    );
  }


  // =====================================================
  // FLUJO DEL MANTENIMIENTO
  // =====================================================

  startMaintenance(
    id: number,
    user_id?: number
  ): Observable<any> {

    return this.http.put<any>(
      `${this.api}/${id}/start`,
      {
        user_id
      },this.headers
    );
  }


  completeMaintenance(
    id: number,
    data: any
  ): Observable<any> {

    return this.http.put<any>(
      `${this.api}/${id}/complete`,
      data,this.headers
    );
  }


  cancelMaintenance(
    id: number,
    user_id?: number
  ): Observable<any> {

    return this.http.put<any>(
      `${this.api}/${id}/cancel`,
      {
        user_id
      },this.headers
    );
  }


  // =====================================================
  // MANTENIMIENTOS POR EQUIPO
  // =====================================================

  getMaintenanceByEquipment(
    equipmentId: number
  ): Observable<any> {

    return this.http.get<any>(
      `${this.api}/equipment/${equipmentId}`,this.headers
    );
  }


  getLastMaintenanceEquipment(
    equipmentId: number
  ): Observable<any> {

    return this.http.get<any>(
      `${this.api}/equipment/${equipmentId}/last`,this.headers
    );
  }


  getNextMaintenanceEquipment(
    equipmentId: number
  ): Observable<any> {

    return this.http.get<any>(
      `${this.api}/equipment/${equipmentId}/next`,this.headers
    );
  }


  // =====================================================
  // HISTORIAL
  // =====================================================

  getMaintenanceHistory(
    id: number
  ): Observable<any> {

    return this.http.get<any>(
      `${this.api}/${id}/history`,this.headers
    );
  }


  getEquipmentMaintenanceHistory(
    equipmentId: number
  ): Observable<any> {

    return this.http.get<any>(
      `${this.api}/equipment/${equipmentId}/history`,this.headers
    );
  }

}
